import makeActionCreator from 'make-action-creator'

export const fetchProfile = makeActionCreator('profile/fetchProfile')